import { Link, useLocation } from 'react-router-dom';
import * as icons from '@mui/icons-material';
import { List, ListItem, ListItemIcon, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PrefetchRoutes, Routes, usePrefetchRoutes } from 'src/services/helpers/prefetch';
import { RootStateType } from 'src/services/redux/reducers';
import { useSelector } from 'react-redux';
import { Colors } from './styles/colors';
import { getRoutePath } from './helper/getRoutePath';
import { ModuleDisplayName, getRouteForModule } from './helper/modulesHelper';

type NavigationMenuProps = {
  listItemDirection: 'row' | 'column';
  listDirection: 'row' | 'column';
  justifyContent: 'center' | 'flex-start' | 'flex-end' | 'space-between';
  padding: number;
};

export const NavigationMenu = (props: NavigationMenuProps) => {
  const { listItemDirection, justifyContent, padding, listDirection } = props;
  const location = useLocation();
  const { t } = useTranslation();
  const currentPath = getRoutePath(location.pathname);
  const { modules } = useSelector((state: RootStateType) => state.appState);
  const prefetch = usePrefetchRoutes<Routes>();

  return (
    <List
      component='nav'
      sx={{
        '&.Mui-disabled': { pointerEvents: 'auto' },
        display: 'flex',
        flexDirection: listDirection,
        justifyContent: 'space-between',
        width: 650,
      }}
    >
      {modules
        ?.filter((item) => item.Title !== 'Chat')
        .map((item) => {
          const capitalizeFirstLetter = (str?: string): string => {
            if (!str) return ''; // Hanterar undefined, null och tomma strängar
            return str.charAt(0).toUpperCase() + str.slice(1);
          };
          const iconKey = capitalizeFirstLetter(item.WebIcon) as keyof typeof icons;
          const IconComponent = icons[iconKey] || icons.ErrorOutline;
          return (
            <ListItem
              sx={{
                p: padding,
                textAlign: 'center',
                display: 'flex',
                justifyContent,
              }}
              button
              key={item.Title}
              component={Link}
              to={getRouteForModule(item.Title)}
              onMouseEnter={
                item.Title && ['Calendar', 'Progress', 'Career'].includes(item.Title)
                  ? prefetch[item.Title.toLowerCase() as keyof PrefetchRoutes<Routes>]
                  : undefined
              }
            >
              <Box display='flex' flexDirection={listItemDirection}>
                <ListItemIcon
                  sx={{
                    minWidth: 40,
                    justifyContent: 'center',
                    color: currentPath === getRouteForModule(item.Title) ? Colors.ACCENT_DARK : '',
                  }}
                >
                  <IconComponent />
                </ListItemIcon>
                <Typography
                  variant='subtitle1'
                  sx={{
                    color: currentPath === getRouteForModule(item.Title) ? Colors.ACCENT_DARK : '',
                  }}
                >
                  <ModuleDisplayName moduleTitle={item.Title} />
                </Typography>
              </Box>
            </ListItem>
          );
        })}
    </List>
  );
};
